module.exports = __webpack_public_path__ + "static/img/image 2.c3d776e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xh/images/image 2.png
// module id = Yh0n
// module chunks = 8